import { StringValueObject } from 'src/core/common/domain/value-objects/string-value-object';

export class AuthToken extends StringValueObject {}
